import React, { useState } from 'react';
import { useTranslation } from 'react-i18next'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types'
import SelectField from '../selectField';

// helpers
import { getDomainNames } from '../../helpers/general'
import { makeForgotPasswordDTO } from './forgotPassword.helpers';

// services
import { forgotPassword } from '../../services/user';
import styles from './forgotPassword.module.scss';
import { noop } from '../../utils/general'

const ForgotPassword = ({ showModal, handleClose, userId, userEmail }) => {
  const [domainName, setDomainName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { t } = useTranslation()

  const setAsSubmitted = () => setIsSubmitting(false);

  const handleForgotPasswordSuccess = () => {
    toast.success(t('forgot-password-success'))
    handleClose();
  };

  const handleForgotPasswordFailure = (err) => {
    toast.error(err.message)
  };

  const handleForgotPassword = () => {
    const forgotPasswordDTO = makeForgotPasswordDTO(domainName);
    setIsSubmitting(true)
    forgotPassword(forgotPasswordDTO, userId)
      .then(handleForgotPasswordSuccess)
      .catch(handleForgotPasswordFailure)
      .finally(setAsSubmitted);
  };

  const handleDomainNameChange = (event) => {
    event?.stopPropagation();
    const { value } = event?.target || {};
    setDomainName(value);
  };

  return (
    <Dialog open={showModal} onClose={handleClose} onClick={(e) => e.stopPropagation()}>
      <DialogTitle className={styles.heading}>
        Forgot Password
        <IconButton
          aria-label="close"
          onClick={handleClose}
          className={styles.iconBtn}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className={styles.container}>
        <div className={styles.resetMsg}>
          {`Forget password email will be sent to ${userEmail}. Continue?`}
        </div>
        <SelectField
          options={getDomainNames()}
          label="Send email through"
          id="domainName"
          value={domainName}
          error=""
          onChange={handleDomainNameChange}
        />
      </DialogContent>
      <DialogActions className={styles.actions}>
        <Button
          onClick={handleClose}
          type="submit"
          className={styles.cancelBtn}
          variant="contained"
          disabled={isSubmitting}
          sx={{ marginTop: '20px' }}
          data-testid="forgotPasswordCancel"
        >
          Cancel
        </Button>
        <Button
          onClick={handleForgotPassword}
          type="submit"
          className={styles.continueBtn}
          variant="contained"
          sx={{ marginTop: '20px', marginLeft: '10px' }}
          disabled={isSubmitting || !domainName}
          data-testid="forgotPasswordSubmit"
        >
          Continue to send
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ForgotPassword.propTypes = {
  showModal: PropTypes.bool,
  handleClose: PropTypes.func,
  userId: PropTypes.string,
  userEmail: PropTypes.string
}

ForgotPassword.defaultProps = {
  showModal: false,
  handleClose: noop,
  userId: '',
  userEmail: ''
}

export default ForgotPassword;
